module.exports = __webpack_public_path__ + "static/media/app-store-black.844dbfe9.svg";